import React from 'react';
import utils from 'common/utils';
import store from 'common/services/storage';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';

export default withRouter(class AuthRequired extends React.Component {
  constructor(props) {
    super(props);
    let ref = this.props.redirectTo;
    if (utils.isEmpty(this.props.redirectTo)) {
      ref = `${this.props.location.pathname || ''}${this.props.location.search || ''}`;
    } else if (this.props.location && this.props.location.search) {
      ref = `${this.props.redirectTo}${this.props.location.search}`;
    }
    store.set('loginRef', ref, true);
  }
  render () {
    const uid = store.get('LOGIN_UID');
    if (utils.isEmpty(uid)) {
      return <Redirect to='/userLogin'/>;
    } else{
      return (this.props.onRender);
    }
  }
});
